module.exports = __webpack_public_path__ + "c89c9641a662acf53686a3dd4f41abd2.png";